module.exports = __webpack_public_path__ + "static/media/v35.0222189c.mp4";